// ZIMMERDATEN – zentral editierbar. Summe: 8 Zimmer, 27 Einzelbetten.
import type { Localized } from "./site";
import { images } from "./images";

export type RoomCategory = {
  id: string;
  name: Localized;
  rooms: number;
  beds: number;
  image: string;
  imageIsPlaceholder: boolean;
  description: Localized;
};

export const roomCategories: RoomCategory[] = [
  {
    id: "5-bett",
    name: { de: "5-Bett-Zimmer", en: "5-bed room" },
    rooms: 2,
    beds: 5,
    image: images.room5,
    imageIsPlaceholder: false,
    description: {
      de: "Großzügiges Zimmer mit fünf Einzelbetten – ideal für Teams und Gruppen, die gemeinsam unterwegs sind.",
      en: "Spacious room with five single beds – ideal for teams and groups travelling together.",
    },
  },
  {
    id: "4-bett",
    name: { de: "4-Bett-Zimmer", en: "4-bed room" },
    rooms: 1,
    beds: 4,
    image: images.room4,
    imageIsPlaceholder: false,
    description: {
      de: "Vier Einzelbetten in einem Zimmer – praktisch für kleinere Arbeitsgruppen.",
      en: "Four single beds in one room – practical for smaller work crews.",
    },
  },
  {
    id: "3-bett",
    name: { de: "3-Bett-Zimmer", en: "3-bed room" },
    rooms: 3,
    beds: 3,
    image: images.room3,
    imageIsPlaceholder: false,
    description: {
      de: "Drei Einzelbetten – unsere flexibelste Zimmergröße, dreimal im Haus vorhanden.",
      en: "Three single beds – our most flexible room size, available three times in the house.",
    },
  },
  {
    id: "2-bett",
    name: { de: "2-Bett-Zimmer", en: "2-bed room" },
    rooms: 2,
    beds: 2,
    image: images.room2,
    imageIsPlaceholder: false,
    description: {
      de: "Zwei Einzelbetten – ruhig und übersichtlich für zwei Personen.",
      en: "Two single beds – calm and simple for two guests.",
    },
  },
];

export const totalRooms = roomCategories.reduce((s, r) => s + r.rooms, 0);
export const totalBeds = roomCategories.reduce((s, r) => s + r.rooms * r.beds, 0);
